// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cynz","label":"styles_label__3445l"};